<acl-ngx-accordion title="Forecast Blueprint" [open]="true">
    <div>
        <ng-template #funnelWidget>
            <campaign-object-exclusion [props]="{data: funnelData}"></campaign-object-exclusion>
        </ng-template>
        <acl-ngx-card [renderBody]="funnelWidget"></acl-ngx-card>
    </div>
</acl-ngx-accordion>
